import { createSlice } from "@reduxjs/toolkit";

import { RootState } from '../../index';
import { DispatchType } from "../..";
import membersService from "../../../../services/api/paro/membersService";


const initialState = {
    list: {} as { [index: number]: any[] },
    loading: true,
    filters: null,
    pager: {
        pageSize: 0,
        page: 1,
        totalCount: 0
    },
    loadingError: false
};


const slice = createSlice({
    name: "members",
    initialState: initialState,
    reducers: {
        membersRequested: (state, action) => {
            state.loading = true;
            state.filters = action.payload.filters;
            state.pager.page = action.payload.page;
            state.loadingError = false;
        },
        membersReceived: (state, action) => {
            state.list[action.payload.pager.page] = action.payload.data;
            state.pager = action.payload.pager;
            state.loading = false;
        },
        membersRequestFailed: (state, action) => {
            state.loadingError = true;
            state.loading = false;
        },
        updateMemberRecord: (state, action) => {
            const { member, page } = action.payload;

            const list = state.list[page];
            if (list) {
                const index = list.findIndex(memberItem => memberItem.id === member.id);
                list[index] = { ...member };

                state.list[page] = list;
            }
        },
        getCachedMember: (state, action) => {
            state.pager.page = action.payload.page;
        },
        clearCachedMember: (state, action) => {
            state.list = {};
        },
        resetMembers: (state, action) => initialState,
    }
});


const { membersRequested, getCachedMember, membersRequestFailed, membersReceived, clearCachedMember } = slice.actions;
export const { resetMembers, updateMemberRecord } = slice.actions;




// Actions
export const loadMembers = (payload: any) => async (dispatch: DispatchType, getState: () => RootState) => {
    const members = getState().entities.members;
    const sameFilters = JSON.stringify(payload.filters) === JSON.stringify(members.filters);

    // load from cache when page is already loaded
    if (members.list[payload.page] && sameFilters) {
        dispatch(getCachedMember({
            page: payload.page
        }));

        return;
    }


    if (!sameFilters) {
        dispatch(clearCachedMember({}));
    }


    dispatch(membersRequested(payload));
    const result = await membersService.getMembers({
        //remove null and undefined values
        ...Object.fromEntries(Object.entries(payload.filters).filter(([_, v]) => v)),
        page: payload.page,
        pageSize: 10,
        // direction: 'desc',
        // properties: 'id',
    });

    if (result.success) {
        dispatch(membersReceived(result));
    } else {
        dispatch(membersRequestFailed({}));
    }
};




// Selectors
export const selectMembers = (state: RootState): MembersSelectorType => {
    const members = { ...state.entities.members };
    members.list = members.list[state.entities.members.pager.page] || [];

    return members as MembersSelectorType;
};


type MembersSelectorType = Omit<typeof initialState, 'list'> & {
    list: any[];
}


export default slice.reducer;